import * as actionTypes from './actionTypes';

export const getSubscriptionsList = () => ({
    type: actionTypes.GET_SUBSCRIPTIONS_LIST,
});

export const getSubscriptionsListSucceeded = (payload) => ({
    type: actionTypes.GET_SUBSCRIPTIONS_LIST_SUCCEEDED,
    payload,
});

export const getSubscriptionDetails = (clientSubscriptionId) => ({
    type: actionTypes.GET_SUBSCRIPTION_DETAILS,
    clientSubscriptionId,
});

export const setSubscriptionDetails = (payload) => ({
    type: actionTypes.SET_SUBSCRIPTION_DETAILS,
    payload,
});

export const setActiveSubscription = ({ subscription }) => ({
    type: actionTypes.SET_ACTIVE_SUBSCRIPTION,
    payload: subscription,
})

export const removeActiveSubscription = () => ({
    type: actionTypes.REMOVE_ACTIVE_SUBSCRIPTION,
})

export const getUsages = (clientSubscriptionId, startDate) => ({
    type: actionTypes.GET_USAGES,
    clientSubscriptionId,
    startDate,
});

export const setMonthlyUsages = (payload) => ({
    type: actionTypes.SET_MONTHLY_USAGES,
    payload,
});

export const setWeeklyUsages = (payload) => ({
    type: actionTypes.SET_WEEKLY_USAGES,
    payload,
});

export const setConfirmText = ({ confirmText }) => ({
    type: actionTypes.SET_CONFIRM_TEXT,
    payload: {
        confirmText
    },
});

export const getConfirmText = ({
    subscriptionId, startDate
}) => ({
    type: actionTypes.SUBSCRIPTIONS_ITEM_CONFIRM_TEXT,
    payload: {
        subscriptionId,
        startDate,
    },
});

export const buySubscriptionsItem = ({ subscriptionId, startDate }) => ({
    type: actionTypes.SUBSCRIPTIONS_ITEM_BUY,
    payload: {
        subscriptionId,
        startDate,
    },
});

export const setPaymentStatus = ({ status }) => ({
    type: actionTypes.SUBSCRIPTIONS_SET_PAYMENT_STATUS,
    payload: {
        status
    },
})

export const buySubscriptionsItemSucceeded = ({ id }) => ({
    type: actionTypes.SUBSCRIPTIONS_ITEM_BUY_SUCCEEDED,
    payload: {
        id
    }
})

export const setPaymentLink = ({ paymentLink }) => ({
    type: actionTypes.SET_PAYMENT_LINK,
    payload: {
        paymentLink
    }
})
